import { SliceCaseReducers } from "@reduxjs/toolkit";
import CreateGenericSlice from "../GenericSlice";

const store = CreateGenericSlice<
  DateFilterViewModel,
  SliceCaseReducers<DateFilterViewModel>
>({
  name: "dateFilter",
  initialState: {},
  reducers: {
    setDateFilter: (state, { payload }: { payload: DateFilterViewModel }) => {
      state.from = payload.from;
      state.to = payload.to;
    },
  },
});

export const { setDateFilter } = store.actions;

export default store.reducer;
